import {
  DB_LIST_ROLES,
  DB_LIST_PERMISSIONS,
  DB_GET_ROLE,
} from "constants/ActionTypes"

const INIT_STATE = {
  db_roles: [],
  db_all_permissions: [],
  db_curr_role: null,
}

export default (state = INIT_STATE, action) => {
  switch(action.type) {
    case DB_LIST_ROLES: {
      return {
        ...state,
        db_roles: action.payload.roles
      }
    }

    case DB_LIST_PERMISSIONS: {
      return {
        ...state,
        db_all_permissions: action.payload.permissions
      }
    }

    case DB_GET_ROLE: {
      return {
        ...state,
        db_curr_role: action.payload.role
      }
    }

    default: 
      return state;
  }
}